import React from "react";
import {images} from "../../assets/constant"
import SocialMedia from "./SocialMedia";
import resume from "../../assets/content/resume.pdf"

export default function Header() {
  const titles = [
    {
      "id":"1477caf2-c3b5-4af5-aeb5-7d0dca861c56",
      "title": "Security Engineer",
      "years": "3+ years"
    },
    {
      "id":"57261ed9-5ed8-4652-aaaf-c7f59d9ec9f3",
      "title": "QA Engineer",
      "years": "8+ years"
    },
    {
      "id":"bbe9932e-9e29-4845-9649-9493f16e4833",
      "title": "TA Mentor",
      "years": "2+ years"
    }
  ]

  const displayTitles = titles.map(({id, title, years}) => (
    <div className="text-center" key={id}>
      <h3 className="text-[0.938rem] font-semibold text-title leading-tight">
        {title.split(" ")[0]}<br/>{title.split(" ")[1]}
      </h3>
      <p className="text-[0.75rem] font-medium text-muted mt-0.5">{years}</p>
    </div>
  ))

  return (
    <header className="relative pt-10 pb-2">
      <div className="container text-center">

        {/* Profile image + name + social */}
        <div className="flex flex-col items-center">
          <div className="w-[115px] h-[115px] rounded-full border-[3.5px] border-accent grid place-items-center">
            <div className="w-[100px] h-[100px] rounded-full overflow-hidden bg-gradient-to-b from-accent to-accent/20 flex items-end justify-center">
              <img src={images.profile2Removebg} alt="Huy Phu" className="w-[75px]" />
            </div>
          </div>
          <h2 className="text-[1.25rem] font-semibold text-title mt-2">Huy Phu</h2>
          <SocialMedia />
        </div>

        {/* Experience stats */}
        <div className="inline-grid grid-cols-[repeat(3,max-content)] gap-x-10 mt-7">
          {displayTitles}
        </div>

        {/* Buttons */}
        <div className="flex items-center justify-center gap-4 mt-4 mb-8">
          <a
            href={resume}
            className="inline-flex items-center gap-2 bg-accent text-white text-sm px-4 py-2.5 rounded-lg hover:bg-accent-hover transition-colors shadow-accent"
            target="_blank"
            rel="noreferrer"
          >
            Resume <i className="ri-download-line text-xl"></i>
          </a>
          <div className="flex gap-1">
            <a
              href="https://www.credly.com/users/hhphu"
              target="_blank"
              rel="noreferrer"
              className="p-2 bg-surface text-title rounded-lg hover:bg-subtle transition-colors"
            >
              <i className="ri-award-line text-base"></i>
            </a>
            <a
              href="mailto:harry.hphu@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="p-2 bg-surface text-title rounded-lg hover:bg-subtle transition-colors"
            >
              <i className="ri-mail-line text-base"></i>
            </a>
          </div>
        </div>

      </div>
    </header>
  );
}
